import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';

import Alert from 'components/alerts/Alert/Alert';
import AlertDanger from 'components/alerts/AlertDanger/AlertDanger';
import StripeSubscriptionWarning from 'components/alerts/StripeSubscriptionWarning/StripeSubscriptionWarning';
import Loading from 'components/Loading/Loading';
import TeacherProfile from 'components/TeacherProfile/TeacherProfile';

import './style.css';

class TeacherList extends Component {
  componentDidUpdate() {
    const { bookingData, visibleTeachers } = this.props;

    if (bookingData) {
      const teacher = visibleTeachers[bookingData.resourceId];
      if (teacher) {
        browserHistory.push(`/schedule-lesson/${teacher.slug}`);
      }
    }
  }

  renderLoading() {
    return (
      <div className="TeacherList">
        <Loading />
      </div>
    );
  }

  renderError(error, classes) {
    return (
      <div className="TeacherList">
        <AlertDanger className={classes} error={error} />
      </div>
    );
  }

  renderSubscriptionWarning() {
    return (
      <div className="TeacherList">
        <StripeSubscriptionWarning />
      </div>
    );
  }

  renderEmptyList() {
    const selectedDayPlusOne = this.props.selectedDay.clone().add(1, 'day');

    return (
      <div className="TeacherList">
        <Alert className="EmptyList" alertType="primary">
          <div className="card-block">
            {moment()
              .add(12, 'hour')
              .isAfter(selectedDayPlusOne, 'minute') ?
              this.renderBookingLimitsViolation() :
              this.renderChangeFilters()}
          </div>
        </Alert>
      </div>
    );
  }

  renderChangeFilters() {
    return (
      <div>
        <h4>Oops!! No Teachers Match Your Criteria</h4>

        <p>
          Looks like we don&#39;t have any teachers that match your search criteria. Please search using
          different dates and/or times.
        </p>
      </div>
    );
  }

  renderBookingLimitsViolation() {
    return (
      <div>
        <h4>Oops!! Looks Like You’re Trying to Book a Lesson Without Enough Notice</h4>

        <p>
          Our teachers need time to prepare a lesson for each student individually. Please search
          for a time more than 12 hours from now.
        </p>
      </div>
    );
  }

  renderPause() {
    return (
      <div className="TeacherList error">
        <h4>Your Membership is Currently on Pause.</h4>

        <p>
          It will resume on {moment(this.props.user.profile.pause.endDate).format('MMMM DD, YYYY')}{' '}
          or you can&nbsp;
          <a href="/profile/plans-and-billing">reactivate your membership now</a> to book a lesson.
        </p>
      </div>
    );
  }

  render() {
    const { isAuthenticated, visibleTeachers, selectedDay, user } = this.props;

    if (isAuthenticated && this.props.user.profile.pause) {
      return this.renderPause();
    }

    if (!selectedDay ||
      visibleTeachers.status === 'loading' ||
      visibleTeachers.status === 'init'
    ) {
      return this.renderLoading();
    }

    if (visibleTeachers.error) {
      return this.renderError(visibleTeachers.error, 'TeacherListError');
    }

    // TODO: Let's check the stripe subscription if necessary here but even
    // better would be checking before this component loads in a parent component
    // or HOC and then sending a user to a page that explains how to fix the issue
    // before we even get here

    // if (isAuthenticated && stripeCustomer.error) {
    //   return this.renderError(stripeCustomer.error, 'StripeSubscriptionError');
    // }

    // console.log('stripeCustomer:', stripeCustomer);
    // console.log('this.props.activeStripeSubscriptions:', this.props.activeStripeSubscriptions);
    // if (
    //   isAuthenticated &&
    //   (stripeCustomer.delinquent === true || _.isEmpty(this.props.activeStripeSubscriptions))
    // ) {
    //   return this.renderSubscriptionWarning();
    // }

    if (_.isEmpty(visibleTeachers.availableTimes)) {
      return this.renderEmptyList();
    }

    return (
      <div className="TeacherList">
        {_.map(visibleTeachers.availableTimes, teacher => {
          return (
            <Link className="bg-secondary" to={`/schedule-lesson/${teacher.slug}`} key={teacher.id} data-qa-id="teacher-list-item-link">
              <TeacherProfile teacher={teacher} user={user.profile} hasReadMore />
            </Link>
          );
        })}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isAuthenticated: !_.isEmpty(state.user.profile),
    selectedDay: state.filters.selectedDay,
    visibleTeachers: state.availability,
    bookingData: state.user.bookingData,
    user: state.user
  };
}

export default connect(mapStateToProps)(TeacherList);



// WEBPACK FOOTER //
// ./src/pages/student/TeacherList/index.js